import React from "react";

import TextBlockEditor from "../../lesson/TextBlockEditor"; // <-- adjust path
import CodeBlockEditor from "../../lesson/CodeBlockEditor"; // <-- adjust path

import LinkBlockEditor from "./LinkBlockEditor";
import CodeEditor from "../../../../../../../components/elements/CodeEditor";
import CodeLanguageEditor from "./CodeLanguageEditor";

export default function BlockTypeSwitcher({ block, onChange }) {
    if (!block || !block.type) return null;

    switch (block.type) {
        case "text":
            return (
                <TextBlockEditor
                    block={block}
                    onChange={onChange}
                />
            );

        case "code":
            return (
                <CodeLanguageEditor
                    value={block}
                    language={block?.config?.language || "javascript"}
                    onChange={onChange}
                />
            );

        case "link":
            return (
                <LinkBlockEditor
                    value={block}
                    onChange={onChange}
                />
            );

        default:
            return (
                <div style={{ fontSize: 12, color: "crimson" }}>
                    Unknown block type: <code>{String(block.type)}</code>
                </div>
            );
    }
}
